import { createSelector } from 'reselect';

const selectAssociatedCampaign = (state: any) => state.associatedCampaign;


export const selectAssociatedCampaignCurrentItem = createSelector([selectAssociatedCampaign], (associatedCampaign) => associatedCampaign.current);

export const selectAssociatedCampaignListItems = createSelector([selectAssociatedCampaign], (associatedCampaign) => associatedCampaign.list);

export const selectAssociatedCampaignItemById = (itemId: any) =>
    createSelector(selectAssociatedCampaignListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectAssociatedCampaignQueryItems = createSelector([selectAssociatedCampaign], (associatedCampaign) => associatedCampaign.query);

export const selectAssociatedCampaignCreatedItem = createSelector([selectAssociatedCampaign], (associatedCampaign) => associatedCampaign.create);

export const selectAssociatedCampaignUpdatedItem = createSelector([selectAssociatedCampaign], (associatedCampaign) => associatedCampaign.update);

export const selectReadItem = createSelector([selectAssociatedCampaign], (associatedCampaign) => associatedCampaign.read);

export const selectAssociatedCampaignDeletedItem = createSelector([selectAssociatedCampaign], (associatedCampaign) => associatedCampaign.delete);

export const selectAssociatedCampaignearchedItems = createSelector([selectAssociatedCampaign], (associatedCampaign) => associatedCampaign.search);

export const selectAssociatedCampaignItemsCount = createSelector([selectAssociatedCampaign], (associatedCampaign) => associatedCampaign.count);

export const selectAssociatedCampaignItemsFilter = createSelector([selectAssociatedCampaign], (associatedCampaign) => associatedCampaign.filter);